const Setting = () => {
  return <>Setting</>;
};

export default Setting;
